import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["data-error"]
const _hoisted_2 = {
  key: 1,
  class: "b-dropdown__toggler border-radius flex middle-xs between-xs regular fs-general"
}
const _hoisted_3 = {
  key: 0,
  class: "black"
}
const _hoisted_4 = {
  key: 1,
  class: "transparent-grey"
}
const _hoisted_5 = { class: "b-dropdown__options border-radius" }
const _hoisted_6 = {
  key: 1,
  class: "b-dropdown__options_list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "regular black" }

import { ref, useSlots } from 'vue';
  import DropdownFilledIcon from '@/views/icons/DropdownFilledIcon.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDropdownComponent',
  props: {
    modelValue: {
      type: Object,
    },
    options: {
      type: Array<Object>,
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    displayKey: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    highlightActive: {
      type: Boolean,
      default: false,
    },
    errorText: String,
  },
  emits: ["update:modelValue"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'update:modelValue', payload: Object): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props

  

  const slots = useSlots();

  

  const dropdownRef = ref<HTMLDivElement>(null);
  const isOpen = ref<boolean>(false);

  function onClickOutside(e: any) {
    if (isOpen.value) {
      e?.stopImmediatePropagation();
    }

    closeDropdown();
  }

  function closeDropdown() {
    isOpen.value = false;
  }

  function toggleDropdown() {
    isOpen.value = !isOpen.value;
  }

  function select(index) {
    const selectedOption = props.options[index];
    emit('update:modelValue', selectedOption);
    closeDropdown();
  }

  expose({
    isOpen,
  });

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: _normalizeClass(["b-dropdown", { 'has-error': !!__props.errorText }]),
    "data-error": __props.errorText
  }, [
    _createElementVNode("div", { onClick: toggleDropdown }, [
      (_unref(slots).display)
        ? _renderSlot(_ctx.$slots, "display", { key: 0 })
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.modelValue && __props.displayKey in __props.modelValue)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.modelValue[__props.displayKey]), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.placeholder), 1)),
            _createVNode(DropdownFilledIcon, { fillOpacity: "0.54" })
          ]))
    ]),
    _createVNode(_Transition, { name: "dropdown" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          (_unref(slots).default)
            ? _renderSlot(_ctx.$slots, "default", { key: 0 })
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["b-dropdown__options_item flex middle-xs", {
                'b-dropdown__options_item--highlight':
                  __props.highlightActive &&
                  __props.modelValue &&
                  option[__props.valueKey] === __props.modelValue[__props.valueKey],
              }]),
                    key: i,
                    onClick: ($event: any) => (select(i))
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(__props.displayKey in option ? option[__props.displayKey] : option), 1)
                  ], 10, _hoisted_7))
                }), 128))
              ]))
        ], 512), [
          [_vShow, isOpen.value]
        ])
      ]),
      _: 3
    })
  ], 10, _hoisted_1)), [
    [_directive_click_outside, onClickOutside]
  ])
}
}

})